import Button from "@atoms/Button/Button"

import { useStepStack } from "@molecules/StepStack/StepStack.context"
import { StepStackNavButtonProps } from "@molecules/StepStack/StepStack.types"

function StepStackBackButton(props: StepStackNavButtonProps) {
    const { children = "Back", variant = "subtle", size = "md", noDebounce = true, ...rest } = props
    const { orderedIds, currentItemId, navigateTo } = useStepStack()

    const currentIndex = currentItemId ? orderedIds.indexOf(currentItemId) : -1
    const prevId = currentIndex > 0 ? orderedIds[currentIndex - 1] : null
    const isDisabled = prevId === null

    return (
        <Button
            {...rest}
            type="button"
            variant={variant}
            size={size}
            onClick={() => (prevId ? navigateTo(prevId) : undefined)}
            noDebounce={noDebounce}
            isDisabled={isDisabled}
        >
            {children}
        </Button>
    )
}

export default StepStackBackButton
